import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useLangContext } from "../../context/langContext";
import { useSearchParams } from "react-router-dom";
import ErrorAlert from "../../components/common/alert/ErrorAlert";
import SuccessAlert from "../../components/common/alert/SuccessAlert";
import WalletTransactionTableComponent from "../../components/panel/wallet/WalletTransactionTable";

const compInfos = {
  en: {
    title: "Contacts",
    subtitle: "Your Contacts list",
    buttonOne: "upload phone's file",
  },
  fa: {
    title: "تراکنش های کیف پول ",
    subtitle: "تراکنش های کیف پول ",
    buttonOne: "افزایش موجودی",
  },
};

export default function WalletTransactionPage() {
  const { lang } = useLangContext();
  const [searchParams] = useSearchParams();
  const paymentStatus = searchParams.get("status");

  const infos = compInfos[lang];
  const [walletReload, setWalletReload] = useState<boolean>(false);

  return (
    <>
      {paymentStatus && (
        <Stack py="10px" px="6px" width="100%">
          {paymentStatus == "failed" ? (
            <ErrorAlert
              msgTitle="پرداخت ناموفق"
              msgDesc="در صورت کسر وجوه از حساب شما تا ۷۲ ساعت وجوه به حساب شما استرداد می یابد."
            />
          ) : (
            <SuccessAlert
              msgTitle="پرداخت موفق"
              msgDesc="کیف پول شما با موفقیت شارژ شد."
            />
          )}
        </Stack>
      )}
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={(theme) => theme.palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                {infos.title}
              </Typography>
              <Typography
                variant="footerDemiBold"
                sx={{
                  mb: "20px",
                  color: ({ palette }) => palette.complement[300],
                }}
              >
                {infos.subtitle}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
            >
              {/* <Button
                onClick={() => setOpenWalletModal(true)}
                variant="contained"
              >
                {infos.buttonOne}
              </Button> */}
            </Stack>
          </Stack>
        </Stack>
        <WalletTransactionTableComponent
          walletReload={walletReload}
          setWalletReload={setWalletReload}
        />
      </Stack>
    </>
  );
}
